import script from "./updateaccount.vue?vue&type=script&setup=true&lang=js"
export * from "./updateaccount.vue?vue&type=script&setup=true&lang=js"

import "./updateaccount.vue?vue&type=style&index=0&id=b16d07ec&scoped=true&lang=css"

import exportComponent from "F:\\proj-abhinav\\meraki\\patient-portal-v3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b16d07ec"]])

export default __exports__